import { SeatingArea as SeatingAreaModel } from '@models/SeatingArea'
import { useAppSelector } from '@store/hooks'
import { selectSeatingAreaById } from '@store/SeatingAreaReducer'
import { SBModelComponent } from '@supplement-bacon/react-toolkit/models'
import { Flex, Tag } from 'antd'
import { AvatarProps } from 'antd/es/avatar'
import { FC } from 'react'
import { Localizable } from '../localizable/Localizable'

type Props = SBModelComponent<SeatingAreaModel> & {
  size?: AvatarProps['size']
  type?: 'full' | 'condensed'
}

const SeatingAreaAvatar: FC<Props> = ({
  id,
  model,
  size = 'default',
  type = 'full',
}) => {
  const item = model ? model : useAppSelector(selectSeatingAreaById(id!))

  if (!item) {
    return <></>
  }
  return (
    <Flex gap={8} wrap>
      <Localizable.Render
        item={item}
        render={(localizedItem, lang) => (
          <Tag icon={lang.flag}> {localizedItem.name}</Tag>
        )}
      />
    </Flex>
  )
}

type SeatingAreaAvatarType = { Avatar: typeof SeatingAreaAvatar }

export { SeatingAreaAvatar, type SeatingAreaAvatarType }
